import { Dayjs } from 'dayjs';
import {
  DefaultFetchError,
  FetchCreate, FetchDelete,
  FetchGet,
  FetchGetId,
  FetchSuccess,
  FetchUpdate,
  PagingDataResponse,
  PagingParams,
  useFetchCreate, useFetchDelete,
  useFetchGet,
  useFetchGetId, useFetchUpdate,
} from '../fetch';

export interface Product {
  id: string;
  name: string;
  logo?: string;
  description?: string;
  removed?: boolean;
}

export const useProductsGet = (): FetchGet<Product[], DefaultFetchError> => (
  useFetchGet('products', { authorization: false })
);
